module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('link', {
    attrs: {
      "rel": "stylesheet",
      "href": "https://cdn.jsdelivr.net/npm/bootstrap@4.6.2/dist/css/bootstrap.min.css",
      "integrity": "sha384-xOolHFLEh07PJGoPkLv1IbcEPTNtaed2xpHsD9ESMhqIYd0nLMwNLD69Npy4HI+N",
      "crossorigin": "anonymous"
    }
  }), _vm._v(" "), _c('meta', {
    attrs: {
      "name": "viewport",
      "content": "width=device-width, initial-scale=1, shrink-to-fit=no"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: " col-md-6 col-12 p-0"
  }, [_c('div', {
    staticClass: "col-12 row mx-0 px-3 py-2",
    staticStyle: {
      "background-image": "linear-gradient(rgb(0, 145, 165), rgb(1, 136, 154), rgb(2, 126, 144), rgb(3, 117, 133), rgb(3, 108, 123))",
      "color": "#ffffff"
    }
  }, [_c('h3', [_c('strong', [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][0]))])]), _vm._v(" "), _c('div', {
    staticClass: "ml-auto"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'my-kh',
        params: {
          language: _vm.$route.params.language
        }
      }
    }
  }, [_c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "font-size": "15px",
      "border-radius": "5px"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][17]))])])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-0",
    staticStyle: {
      "background": "#fffdb2"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_c('div', {
    staticClass: "col border-left align-self-center",
    staticStyle: {
      "width": "300px"
    }
  }, [_c('div', {
    staticClass: "col-12 px-4 py-1 row font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][22])), _vm._v(" "), _c('div', {
    staticClass: "col-auto px-2 row mx-0 align-self-center",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.TankV),
      expression: "TankV"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "4",
      "size": "3",
      "name": "TankV",
      "type": "text"
    },
    domProps: {
      "value": (_vm.TankV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.TankV = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][24]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-4 py-1 row font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][23])), _vm._v(" "), _c('div', {
    staticClass: "col-auto px-2 row mx-0 align-self-center",
    staticStyle: {
      "font-size": "1rem"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CaRV),
      expression: "CaRV"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "4",
      "size": "3",
      "name": "CaRV",
      "type": "text"
    },
    domProps: {
      "value": (_vm.CaRV)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.CaRV = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][24]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-4 py-1 row font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][25])), _vm._v(" "), _c('div', {
    staticClass: "col-auto px-2 row mx-0 align-self-center",
    staticStyle: {
      "min-width": "100px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.CoralD),
      expression: "CoralD"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding": "5px",
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "name": "Coral_density"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.CoralD = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "0.5",
      "selected": "selected"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][26]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "1"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][27]))]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "2"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][28]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-0 justify-content-center",
    staticStyle: {
      "background": "#fffdb2"
    }
  }, [_c('button', {
    staticClass: "btn btn-primary mr-2",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.generate
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][29]))]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-secondary",
    staticStyle: {
      "min-width": "150px"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][30]))])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(" " + _vm._s(_vm.msglist[_vm.$route.params.language][31]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.PairDev),
      expression: "PairDev"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "12",
      "name": "PairDev",
      "type": "text"
    },
    domProps: {
      "value": (_vm.PairDev)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.PairDev = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][21]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.tune_both),
      expression: "tune_both"
    }],
    staticClass: "form-control",
    staticStyle: {
      "padding": "5px",
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "name": "tune_both_value"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.tune_both = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }
    }
  }, [_c('option', {
    attrs: {
      "value": "1",
      "selected": "selected"
    }
  }, [_vm._v("On")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "0"
    }
  }, [_vm._v("Off")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][7]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.KHdosing),
      expression: "KHdosing"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "4",
      "name": "KHdosing",
      "type": "text"
    },
    domProps: {
      "value": (_vm.KHdosing)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.KHdosing = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][9]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][8]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-0 row mx-0 align-self-center",
    staticStyle: {
      "width": "160px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.maxKHdosingPerHr),
      expression: "maxKHdosingPerHr"
    }],
    staticClass: "col form-control text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold"
    },
    attrs: {
      "maxlength": "4",
      "name": "maxKHdosingPerHr",
      "type": "text"
    },
    domProps: {
      "value": (_vm.maxKHdosingPerHr)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.maxKHdosingPerHr = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "col-auto px-2 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][9]))])])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0"
  }, [_vm._m(4), _vm._v(" "), _c('div', {
    staticClass: "col border-left align-self-center"
  }, [_c('div', {
    staticClass: "col-12 px-0 font-weight-bold",
    staticStyle: {
      "font-size": "1.2rem"
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][11]) + " ")]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-0 row mx-0 align-self-center"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ValveOpen),
      expression: "ValveOpen"
    }],
    staticClass: "form-control col align-self-center",
    staticStyle: {
      "width": "100px",
      "height": "10px"
    },
    attrs: {
      "type": "range",
      "min": "0",
      "max": "95"
    },
    domProps: {
      "value": (_vm.ValveOpen)
    },
    on: {
      "__r": function($event) {
        _vm.ValveOpen = $event.target.value
      }
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.ValveOpen),
      expression: "ValveOpen"
    }],
    staticClass: "form-control align-self-center ml-2 px-0 text-center",
    staticStyle: {
      "height": "30px",
      "font-size": "1rem",
      "font-weight": "bold",
      "width": "50px",
      "background": "none",
      "border": "none"
    },
    attrs: {
      "type": "number",
      "min": "0",
      "max": "95"
    },
    domProps: {
      "value": (_vm.ValveOpen)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.ValveOpen = $event.target.value
      }
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(200, 242, 242)"
    }
  }, [_c('div', {
    staticClass: "col-12 px-0 row mx-0 font-weight-bold"
  }, [_c('div', {
    staticClass: "px-3 align-self-center"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][13]))]), _vm._v(" "), _c('div', {
    staticClass: "col align-self-center text-right"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][14]))])])]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, _vm._l((_vm.targetKHarr), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "col-12 px-0 row mx-0 font-weight-bold"
    }, [_c('div', {
      staticClass: "px-3 align-self-center",
      staticStyle: {
        "width": "35px"
      }
    }, [(index < 10) ? _c('span', [_vm._v("0")]) : _vm._e(), _c('span', [_vm._v(_vm._s(index))])]), _vm._v(" "), _c('div', {
      staticClass: "col align-self-center row mx-0 "
    }, [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.targetKHarr[index]),
        expression: "targetKHarr[index]"
      }],
      staticClass: "form-control col align-self-center",
      staticStyle: {
        "width": "50%",
        "height": "10px"
      },
      attrs: {
        "type": "range",
        "min": "0",
        "max": "240"
      },
      domProps: {
        "value": (_vm.targetKHarr[index])
      },
      on: {
        "__r": function($event) {
          _vm.$set(_vm.targetKHarr, index, $event.target.value)
        }
      }
    }), _vm._v(" "), _c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.targetKHarr[index]),
        expression: "targetKHarr[index]"
      }],
      staticClass: "form-control align-self-center ml-2 px-0 text-center",
      staticStyle: {
        "height": "30px",
        "font-size": "1rem",
        "font-weight": "bold",
        "width": "50px",
        "background": "none",
        "border": "none"
      },
      attrs: {
        "type": "number",
        "min": "0",
        "max": "240"
      },
      domProps: {
        "value": (_vm.targetKHarr[index])
      },
      on: {
        "input": function($event) {
          if ($event.target.composing) { return; }
          _vm.$set(_vm.targetKHarr, index, $event.target.value)
        }
      }
    })])])
  })), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-3 mb-1 justify-content-center",
    staticStyle: {
      "background": "rgb(242, 242, 242)"
    }
  }, [(_vm.name !== 'khacra') ? _c('button', {
    staticClass: "btn btn-primary",
    staticStyle: {
      "min-width": "150px"
    },
    attrs: {
      "disabled": _vm.disabled
    },
    on: {
      "click": _vm.apply
    }
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][19]))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "col-12 row mx-0 px-0 py-2 mb-1 justify-content-center"
  }, [_c('div', {
    staticClass: "col-12 px-0"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][15]))]), _vm._v(" "), _c('div', {
    staticClass: "col-12 px-0 mt-3"
  }, [_vm._v(_vm._s(_vm.msglist[_vm.$route.params.language][16]))])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": require("../assets/KHA.png")
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADIAAAAyCAYAAAAeP4ixAAAACXBIWXMAAAsTAAALEwEAmpwYAAADKUlEQVR4nO1YXUgVQRT+3PPNWiBSIVQQJZH2C6G3P6mHiix7qpcKCSIQsqAgiqAfKHpIfAnsJQJfMpKICOklAglfCiKkqIeIQoiwCJ+KjDRCY+AsDJdLXvfuuiPcgQO7c+ac+b5zzszuDBCvzamsrFwOYAlmcyN5luQkyd8A5sew3yAiB4wxa5FlE5E3SsTK8Rj23dZWRK4iq2aMaVQCPxTMC1cfhuEqG22Sm6M+Edlu+wDUisgOkk/VxwMR2euYLyN5kuQ5EdkDoCI1IiJyQ0FcITlsn8MwXB3pSV5Q/V2nb8D2GWOOisgzJ5s2EB/tmCAIDpMcd3WWsF2PafAISY4oeBv5LgXTWSyRMAxXkuxTu25jzDoAi0j+Ijmh2WiOyldEriXOQkT2q/O3CnCrgh626mKIFFojxpg2fX/uzNWife8SJxJFkmS/MeYYyXaSYzphS1wiJC+pzZ3IJgzDOu37kzSPmgI17Mo9BXVe33uLJWL71eaxY7NNxwwlyoLkKXX83u5AkZA843xT5kWgtCRqjDE5kt/yiNx0yC+w603Xx7iI7LR9JB/lZymRJiKD6vhynqqC5GfVtQNYTPJnXrZGXSJOBqx8V/+dBbL81W7JSfKoshPp7lSbrwyC4KDVBUFwRIGuF5FbJHusLgiCQ1ZvsxOZkDxN8r6IXHeCtY/kbZIPtewWJkWg0W6Ns93HUgATAPpLAOCFjxyASQCDJYDwwkfOBxAoE/EsmihnxLNoIqaPuQC2ANgF4IQ6+KDvVupmAkSpPpoAfFGj/0kfgEpfiQQAPqnBa/34FJIRHXPRVyL1OnhoinNys44bSANEEiVe7ITTBRaHSFMpJd6gyldTTLJRx71MiUhQaolXAfgLYAxAm5NCV3YD6FUHPSkRqU+ixDuKSKeVUQBrUiKSS6rEWzXqhdL5BEAXgBVFgopDpCGNEq/WktqE+G26RKrSKPGsfi86ki7xLP+1WpMscV9+GqtLLXFfiOTKR12foolyRjyLJsoZ8SyaKGckw9OdT98RLy8wcjN9uvOFiG8XGNmf7rIm4ssFhp+nO2S0a/lwgYGkHGRygfEP21vvftZoxWYAAAAASUVORK5CYII="
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,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"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-auto align-self-center"
  }, [_c('img', {
    staticStyle: {
      "width": "55px"
    },
    attrs: {
      "src": "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEAAAABACAYAAACqaXHeAAAACXBIWXMAAAsTAAALEwEAmpwYAAAChElEQVR4nO2aO2sVQRiGH0G08HYEo40pvXQqoikE0X8gXhCxEBT8BSKWXpBYqj9AbC1MxEKMChJPDlaKXWpBxVNoohEs1IwMvAtL2JMz0dmTzDf7wMCy8+3MfO98c9mdhYaGmHQAFzm1SQhXU0oGF7nBjQAkGgEu1yHQrsH5VxjCLejR5HrYtACdAazBK1oAN4AJKAkBChoBaCIAl9O7gIswBJLeCLkeAixng/vV8wOYBp4Dl4GdMSpLSYCq9ALY/z+VxRgCsehX3jpgF3AMuAd8lf08cBdYbV2AhbSAUeBnKRr8vWwEKNgHvNezk8AaMhPAMwx81PN3yFAAzwENhz+KiuwE8NxSGc/IVIAWMKNyduQogOe+yrmEoY3Qd2AscPd3XM9MhFSWigBF+gJs71PObtlOh1QWYwjETlV4p58o/0Gfdm0oRU2tArQH/FV4WDazAW3r64+LIMByENrORgACI8DVNKGt+AhoL3H8mRMgNTq5/HPQizqW1qT4V0caATAWAS7XIdCuaXfZ0JA4a/UleFLX2TFaGus3yYy9wC/gt5K/3kMmrFLY+56/raMxfz2lPPOcl8OfgE3ARuCD7p3DOC2gK2dPle6f1r3uUs4IU+S6HH1dEe5TyruKUVo6+PBH4ocq8keU578bbsZw7z9cxGbMahS01LPeuYOL2I3IZkYTpBkuyrGXAbbFEnkBQ0zIqTMBtmdl+xRDdOXUUIDtNtl+xhBzcsr/LEWM47HUeCenDgfYHpXtWwxxQ06NB9g+trgUbgW+yTH/p2gvrpQOUbdgjJPa6XkHHwFHNCesV9gXPT+vHyVMcqIUCVVp1rLzBUPaFr/R6jCn62sWw76BSPwFsjOHITy5npkAAAAASUVORK5CYII="
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-24413240"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaRx_settings.vue
// module id = 516
// module chunks = 0